var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarketplaceLogoFull = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "65 10 270 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.8,9.9v40.1h40.1V9.9H65.8z M90.4,42.2l-14-12.2l0,0h0v-3.3h15.6v-5.7H76.3v-3.3h15.6h3.3v3.3v5.7V30v0 H81.4l14,12.2H90.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.9,41V20.2h4l6.9,14.3l7-14.3h4V41h-3.2V25.1l-6.3,13h-3l-6.3-13V41H116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,40.4l6.9-20.2h5.1l6.8,20.2l-0.4,0.6h-2.7l-1.6-5h-9.4l-1.6,5h-2.7L142.1,40.4z M147.8,33.3h7.6 l-3.5-10.3h-0.7L147.8,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.3,41V20.2h10.3c3.3,0,4.9,1.6,4.9,4.8v3.4c0,2.6-1.1,4.1-3.3,4.6l3.9,7.4l-0.4,0.7H177l-4.2-8h-5.3v8 H164.3z M167.5,30.3h7.1c1.2,0,1.8-0.6,1.8-1.7v-3.9c0-1.1-0.6-1.7-1.8-1.7h-7.1V30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.4,41V20.2h3.2v10l9.2-10h2.9l0.3,0.7l-7.4,7.9l8.1,11.6l-0.3,0.7h-2.9l-6.9-10l-3.1,3.3V41H184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.5,41V20.2h14.2v2.8h-11.1v5.8h10.1v2.8h-10.1v6.7h11.1V41H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,22.9v-2.8h17.2v2.8h-7V41H228V22.9H221z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.7,41V20.2H252c3.3,0,4.9,1.6,4.9,4.8v4c0,3.2-1.6,4.7-4.9,4.7h-7.1V41H241.7z M244.9,30.9h7.1 c1.2,0,1.8-0.6,1.8-1.7v-4.5c0-1.1-0.6-1.7-1.8-1.7h-7.1V30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4,41V20.2h3.2v18.1h10.1V41H261.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,40.4l6.9-20.2h5.1l6.8,20.2l-0.4,0.6h-2.7l-1.6-5h-9.4l-1.6,5h-2.7L276.1,40.4z M281.7,33.3h7.6 l-3.5-10.3h-0.7L281.7,33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.9,36.2V24.9c0-3.2,1.6-4.8,4.9-4.8h8.7l1.6,1.2v1.6h-10.2c-1.2,0-1.7,0.6-1.7,1.7v11.8 c0,1.1,0.6,1.7,1.7,1.7h10.2v1.6l-1.6,1.2h-8.7C299.6,41,297.9,39.4,297.9,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,41V20.2h14.2v2.8h-11.1v5.8h10.1v2.8h-10.1v6.7h11.1V41H317.4z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarketplaceLogoFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marketplace_logo_full.cb5db945dd9c44f60e3f5cde8aed11b5.svg";